import { Box, CardContent, Grid2, Typography, useTheme } from '@mui/material';
import {
  Pattern as PatternIcon,
  CheckCircle as CheckCircleIcon,
  PlaylistAddCheck as PlaylistAddCheckIcon,
  TrendingUp as TrendingUpIcon,
} from '@mui/icons-material';
import { GradientCard, MetricBox } from '../styles';

interface PatternMetricsCardsProps {
  totalPatterns: number;
  activePatterns: number;
  totalMatches: number;
  avgPrecision: number | null;
}

const PatternMetricsCards = ({
  totalPatterns,
  activePatterns,
  totalMatches,
  avgPrecision,
}: PatternMetricsCardsProps) => {
  const theme = useTheme();

  const metrics = [
    {
      label: 'Total Patterns',
      value: totalPatterns,
      icon: <PatternIcon sx={{ fontSize: 32 }} />,
      gradient: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    },
    {
      label: 'Active Patterns',
      value: activePatterns,
      icon: <CheckCircleIcon sx={{ fontSize: 32 }} />,
      gradient: `linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)`,
    },
    {
      label: 'Total Matches',
      value: totalMatches.toLocaleString(),
      icon: <PlaylistAddCheckIcon sx={{ fontSize: 32 }} />,
      gradient: `linear-gradient(135deg, #2196F3 0%, #1565C0 100%)`,
    },
    {
      label: 'Avg Precision',
      value: avgPrecision !== null ? `${avgPrecision.toFixed(1)}%` : 'N/A',
      icon: <TrendingUpIcon sx={{ fontSize: 32 }} />,
      gradient: `linear-gradient(135deg, #FF9800 0%, #E65100 100%)`,
    },
  ];

  return (
    <Grid2 container spacing={2} sx={{ mb: 3 }}>
      {metrics.map(metric => (
        <Grid2 size={{ xs: 6, sm: 3 }} key={metric.label}>
          <GradientCard gradient={metric.gradient}>
            <CardContent sx={{ p: 2 }}>
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box>
                  <Typography variant="caption" sx={{ opacity: 0.9 }}>
                    {metric.label}
                  </Typography>
                  <Typography variant="h4" fontWeight={700}>
                    {metric.value}
                  </Typography>
                </Box>
                <Box sx={{ opacity: 0.8 }}>{metric.icon}</Box>
              </Box>
            </CardContent>
          </GradientCard>
        </Grid2>
      ))}
    </Grid2>
  );
};

export default PatternMetricsCards;
